import { Component, Input, type OnInit } from '@angular/core'
import { CptGoogleTagmanagerService, TransifexService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { SharedService } from '../../../../services/shared.service'
import {
  type DayTimeDTO, DealerDTO, type WorkingDays
} from '../../../../services/dealers.service'
import {
  type WorkingHoursResponse, WorkingHoursService
} from '../../../../services/working-hours.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-dealer-hours',
  standalone: true,
  templateUrl: './dealer-hours.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class DealerHoursComponent implements OnInit {
  @Input() dealer: DealerDTO
  @Input() expanded = false

  service: DayTimeDTO[]
  sales: DayTimeDTO[]

  workingDaysSales: WorkingDays[] = []
  workingDaysService: WorkingDays[] = []

  workingDaysSalesGrouped = {}
  workingDaysServiceGrouped = {}

  openSales = false
  currentDate: Date
  openServices = false
  serviceWorkingHours: WorkingHoursResponse

  constructor (
    private readonly workingHoursService: WorkingHoursService,
    private readonly cptGtmService: CptGoogleTagmanagerService,
    public readonly sharedService: SharedService,
    public transifexService: TransifexService
  ) {}

  ngOnInit (): void {
    this.currentDate = new Date()
    this.service =
      this.dealer.openingHours?.service != null
        ? this.dealer.openingHours.service
        : []
    this.sales =
      this.dealer.openingHours?.sales != null
        ? this.dealer.openingHours.sales
        : []
    if (this.sales.length > 0) {
      this.workingDaysSalesGrouped = this.workingHoursService.showHoursSales(
        this.sales,
        this.workingDaysSales
      )
      this.openSales = this.workingHoursService.calculateIfWorking_v2(
        this.currentDate,
        this.workingDaysSales
      )
    }

    if (this.service.length > 0) {
      this.workingDaysServiceGrouped =
        this.workingHoursService.showHoursService(
          this.service,
          this.workingDaysService
        )
      this.openServices = this.workingHoursService.calculateIfWorking_v2(
        this.currentDate,
        this.workingDaysService
      )
    }

    this.serviceWorkingHours = this.workingHoursService.calculateIfWorking(
      this.service,
      this.currentDate,
      'service'
    )
  }

  originalOrder (): number {
    return 0
  }

  sendContentModulesData (expanded: boolean, contentModuleLabel: string): void {
    this.cptGtmService.sendContentModulesData(
      'Accordion',
      expanded ? 'Open' : 'Close',
      this.sharedService.translateLink(contentModuleLabel) ?? '',
      `Accordion|${this.sharedService.translateLink(contentModuleLabel) ?? ''}`,
      expanded ? 'Open' : 'Close'
    )
  }
}
